<div>
  <mat-card class="mt-2">
    <mat-card-content>
      <mat-card-title class="small-card-title">Contact User</mat-card-title>
      <div class="col-sm-12 pb-2">
        <mat-divider [inset]="true"></mat-divider>
      </div>
      <form>
        <div class="col-sm-12">
          <label>Message *</label>
          <textarea placeholder="Write a message"
                    class="w-100 min-h-text"></textarea>
        </div>
      </form>
      <image-attach title="Drag files here">

      </image-attach>
    </mat-card-content>
    <mat-card-actions>
      <button mat-button class="full-width" [color]="'glb_pinkbtn'" type="submit">
        Submit
      </button>
    </mat-card-actions>
  </mat-card>
</div>
